export default function sessionServiceDecorator($delegate, $rootScope, $state) {
  $rootScope.$on('ng-google-signin:isSignedIn', isSignedInListener);

  function isSignedInListener(e, isSignedIn) {
    if (!isSignedIn) {
      $state.go('auth.signout');
    }
  }
  return $delegate;
}



// WEBPACK FOOTER //
// ./src/app/common/sessionService.decorator.js